module.exports = require("handlebars");


//////////////////
// WEBPACK FOOTER
// external "handlebars"
// module id = 4
// module chunks = 0